namespace $ {

	$mol_style_attach( '$shm_agent_message_text_style', `
		[shm_agent_message_text] [mol_text_paragraph],
		[shm_agent_message_text] [mol_text_header] {
			padding: 0;
		}

		[shm_agent_message_text] [mol_text_table_cell] {
			padding-left: .5rem;
			padding-right: .5rem;
		}

		[shm_agent_message_text_chart_invalid] {
			flex-direction: column;
			gap: .5rem;
		}

		[shm_agent_message_text_chart_error] {
			color: var(--mol_theme_special);
			padding: .5rem;
		}
	` )

}
